import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import ImageUploading from "react-images-uploading";
import { TextValidator, ValidatorForm } from "react-material-ui-form-validator";
import { PhoneInputValidator } from "../../../../utilities/validators";
import UtilHelper from "../../../../utilities/validators/UtilHelper";
import { getUserInfo, setUserInfo } from "../../../../utilities/storage";
import { useStyles } from "./styles";
import EditRoundedIcon from "@material-ui/icons/EditRounded";
import { updateLoggedInUserRequest } from "../../../Auth/AuthApiActions";
import defaultUser from "../../../../assets/user.png";
import ImageLoader from "react-load-image";
import Preloader from "../../../../utilities/components/Preloader/Preloader";
import {
  Box,
  Button,
  Divider,
  Grid,
  Icon,
  Paper,
  Tooltip,
  Typography,
} from "@material-ui/core";
import {
  getSignedUrlRequest,
  getUserByIdRequest,
  updateUserRequest,
  uploadToS3Request,
} from "../../UsersApiActions";

/**
 * function to render doctor profile
 * @param history: history from router
 * @param getUserById: function to get user by id
 * @param updateUser: function to update user
 * @param updateLoggedInUser: fuction to update logged in user
 * @param getSignedUrl: fuction to get signed url
 * @param uploadToS3: fuction to upload file on signed url
 * @returns {JSX.Element}
 * @constructor
 */
const EditProfileFormForDoctors = ({
  history,
  getUserById,
  updateUser,
  updateLoggedInUser,
  getSignedUrl,
  uploadToS3,
  user,
}) => {
  const classes = useStyles();
  const [profileImage, setProfileImage] = useState("");
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [isLoggedInUser, setIsLoggedInUser] = useState(false);
  const [qualifications, setQualifications] = useState([
    { licenseNumber: "", certificates: "", certificateFiles: [] },
  ]);

  useEffect(() => {
    ValidatorForm.addValidationRule("isValidMobile", (value) =>
      UtilHelper.validateMobile(value)
    );

    return () => {
      ValidatorForm.removeValidationRule("isValidMobile");
    };
  }, []);

  useEffect(() => {
    getUserById(getUserInfo().id).then((res) => {
      setFirstName(res.firstName);
      setLastName(res.lastName);
      setEmail(res.email);
      setPhone(res.phone);
      setProfileImage(res.imageUrl);
      setQualifications(
        Array.isArray(res.DoctorQualifications) &&
          res.DoctorQualifications.length > 0
          ? res.DoctorQualifications.map((q) => ({
              licenseNumber: q.licenseNumber || "",
              certificates: q.certificateName || "",
              certificateFiles: [],
            }))
          : [{ licenseNumber: "", certificates: "", certificateFiles: [] }]
      );

      if (res.id === getUserInfo().id) {
        setIsLoggedInUser(true);
      }
    });
  }, [getUserById]);

  /**
   * function to handle edit existing user for doctor profile
   * @param e: event object on form submission
   */
  const onEdit = async (e) => {
    e.preventDefault();

    const userId = getUserInfo().id;

    const data = {
      firstName,
      lastName,
      phone,
      email,
      imageUrl: "",
      qualifications: [],
    };

    try {
      if (typeof profileImage !== "string") {
        const profileImageData = {
          fileName: profileImage[0].file.name,
          fileType: `.${profileImage[0].file.name.split(".").pop()}`,
        };

        const signedProfileRes = await getSignedUrl(profileImageData);
        await uploadToS3(signedProfileRes.urls, profileImage[0].file);
        data.imageUrl = signedProfileRes.path;
      }

      for (const qual of qualifications) {
        const certFiles = [];

        if (qual.certificateFiles?.length > 0) {
          for (const cert of qual.certificateFiles) {
            if (cert.file) {
              const certData = {
                fileName: cert.file.name,
                fileType: `.${cert.file.name.split(".").pop()}`,
              };

              const signedCertRes = await getSignedUrl(certData);
              await uploadToS3(signedCertRes.urls, cert.file);
              certFiles.push(signedCertRes.path);
            }
          }
        }

        data.qualifications.push({
          licenseNumber: qual.licenseNumber,
          certificates: qual.certificates,
          certificateFiles: certFiles,
        });
      }

      const response = isLoggedInUser
        ? await updateLoggedInUser(userId, data)
        : await updateUser(userId, data);

      if (isLoggedInUser) {
        setUserInfo(response);
      }

      history.goBack();
    } catch (error) {
      console.error("User update failed:", error);
    }
  };
  return (
    <Box className={classes.container}>
      <Box component={Paper} className={classes.card}>
        <Box>
          <Box className={classes.cardHeader}>
            <Box className={classes.cardHeaderIcon}>
              <EditRoundedIcon style={{ fontSize: 22 }} />
            </Box>
            <Typography className={classes.cardTitle}>Edit Profile</Typography>
          </Box>

          <Box className={classes.formContainer}>
            <ValidatorForm onSubmit={onEdit}>
              <Grid container spacing={2}>
                <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                  <ImageUploading
                    acceptType={["jpg", "jpeg", "webp", "png"]}
                    maxFileSize={3000000}
                    value={profileImage}
                    onChange={(img) => {
                      setProfileImage(img);
                    }}
                  >
                    {({ onImageUpload, dragProps, errors }) => (
                      <Box>
                        <Box className={classes.profileImageContainer}>
                          <Box onClick={onImageUpload} {...dragProps}>
                            <Box className={classes.uploadContainer}>
                              <Box>
                                <Tooltip
                                  placement="top"
                                  title="Update Photo"
                                  arrow
                                >
                                  <Box>
                                    <ImageLoader
                                      src={
                                        !profileImage
                                          ? defaultUser
                                          : typeof profileImage !== "string"
                                          ? profileImage[0].dataURL
                                          : profileImage
                                      }
                                    >
                                      <img
                                        alt="profile"
                                        className={classes.profileImage}
                                      />
                                      <div
                                        className={classes.profileImageError}
                                      >
                                        err
                                      </div>
                                      <Preloader
                                        className={classes.profileImage}
                                      />
                                    </ImageLoader>
                                  </Box>

                                  {/* <img
                                    src={
                                      !profileImage
                                        ? defaultUser
                                        : typeof profileImage !== 'string'
                                        ? profileImage[0].dataURL
                                        : profileImage
                                    }
                                    alt='profile'
                                    className={classes.profileImage}
                                  /> */}
                                </Tooltip>
                              </Box>

                              <Box className={classes.editIcon}>
                                <Icon color="primary">edit</Icon>
                              </Box>
                            </Box>
                          </Box>

                          {errors && (
                            <Box className={classes.imageErrorContainer}>
                              {errors.acceptType && (
                                <Typography
                                  classes={{ root: classes.imageError }}
                                >
                                  Please select image file
                                </Typography>
                              )}

                              {errors.maxFileSize && (
                                <Typography
                                  classes={{ root: classes.imageError }}
                                >
                                  Selected image file size exceed max file size
                                  (3MB)
                                </Typography>
                              )}
                            </Box>
                          )}
                        </Box>
                      </Box>
                    )}
                  </ImageUploading>
                </Grid>

                <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                  <TextValidator
                    label="First Name *"
                    variant="outlined"
                    fullWidth
                    size="small"
                    value={firstName}
                    onChange={(e) => setFirstName(e.target.value)}
                    validators={["required"]}
                    errorMessages={["Fisrt Name is required"]}
                  />
                </Grid>

                <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                  <TextValidator
                    label="Last Name *"
                    variant="outlined"
                    fullWidth
                    size="small"
                    value={lastName}
                    onChange={(e) => setLastName(e.target.value)}
                    validators={["required"]}
                    errorMessages={["Last Name is required"]}
                  />
                </Grid>

                <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                  <TextValidator
                    disabled
                    label="Email"
                    variant="outlined"
                    fullWidth
                    size="small"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    validators={["required", "isEmail"]}
                    errorMessages={["Email is required", "Email is not valid"]}
                  />
                </Grid>

                <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                  <PhoneInputValidator
                    autoFormat={false}
                    variant="outlined"
                    size="small"
                    label="Phone"
                    fullWidth
                    defaultCountry="in"
                    countryCodeEditable={false}
                    value={phone}
                    onChange={(phone, data) => {
                      let phoneNumber = "+" + phone.replace(/[^0-9]+/g, "");
                      setPhone(phoneNumber);
                    }}
                    validators={["required", "isValidMobile"]}
                    errorMessages={[
                      "Phone is required",
                      "Please enter valid phone",
                    ]}
                  />
                </Grid>
              </Grid>

              {user.Roles[0]?.name === "Doctor" && (
                <>
                  <Divider style={{ margin: "20px 0" }} />
                  <Typography variant="h6" gutterBottom>
                    Qualification
                  </Typography>

                  {qualifications.map((q, index) => (
                    <Grid container spacing={2} key={index}>
                      <Grid item xs={12} sm={6}>
                        <TextValidator
                          label="License Number *"
                          variant="outlined"
                          fullWidth
                          size="small"
                          value={q.licenseNumber}
                          onChange={(e) => {
                            const updated = [...qualifications];
                            updated[index].licenseNumber = e.target.value;
                            setQualifications(updated);
                          }}
                          validators={["required"]}
                          errorMessages={["License number is required"]}
                        />
                      </Grid>

                      <Grid item xs={12} sm={6}>
                        <TextValidator
                          label="Certificates *"
                          variant="outlined"
                          fullWidth
                          size="small"
                          value={q.certificates}
                          onChange={(e) => {
                            const updated = [...qualifications];
                            updated[index].certificates = e.target.value;
                            setQualifications(updated);
                          }}
                          validators={["required"]}
                          errorMessages={["Certificates are required"]}
                        />
                      </Grid>

                      <Grid item xs={12}>
                        <ImageUploading
                          acceptType={["jpg", "jpeg", "png"]}
                          value={q.certificateFiles}
                          onChange={(imageList) => {
                            const updated = [...qualifications];
                            updated[index].certificateFiles = imageList;
                            setQualifications(updated);
                          }}
                          maxNumber={3}
                          maxFileSize={3000000}
                        >
                          {({ onImageUpload, dragProps, errors }) => (
                            <Box>
                              <Button
                                variant="outlined"
                                onClick={onImageUpload}
                                {...dragProps}
                              >
                                Upload Certificate Files
                              </Button>

                              {errors && (
                                <Box>
                                  {errors.acceptType && (
                                    <Typography color="error">
                                      Invalid file type
                                    </Typography>
                                  )}
                                  {errors.maxFileSize && (
                                    <Typography color="error">
                                      File size exceeds maximum (3MB)
                                    </Typography>
                                  )}
                                </Box>
                              )}
                              <Box mt={1}>
                                {q.certificateFiles.map((file, idx) => (
                                  <Typography key={idx}>
                                    {file.file?.name || "Uploaded file"}
                                  </Typography>
                                ))}
                              </Box>
                            </Box>
                          )}
                        </ImageUploading>
                      </Grid>
                    </Grid>
                  ))}

                  <Grid container spacing={2} style={{ marginTop: 16 }}>
                    <Grid item xs={12}>
                      <Button
                        variant="contained"
                        color="primary"
                        onClick={() =>
                          setQualifications([
                            ...qualifications,
                            {
                              licenseNumber: "",
                              certificates: "",
                              certificateFiles: [],
                            },
                          ])
                        }
                      >
                        Add More
                      </Button>
                    </Grid>
                  </Grid>
                </>
              )}
              <Grid
                container
                spacing={2}
                style={{ marginTop: 16, width: "10%" }}
              >
                <Grid item xs={12}>
                  <Button
                    type="submit"
                    fullWidth
                    variant="contained"
                    color="primary"
                    disableElevation={true}
                  >
                    Save
                  </Button>
                </Grid>
              </Grid>
            </ValidatorForm>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

const mapStateToProps = (state) => {
  return {
    user: state.auth.loggedInUser,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getUserById: (id) => {
      return dispatch(getUserByIdRequest(id)).then(
        (res) => {
          return Promise.resolve(res);
        },
        (error) => {
          return Promise.reject(error);
        }
      );
    },
    updateUser: (id, data) => {
      return dispatch(updateUserRequest(id, data)).then(
        (res) => {
          return Promise.resolve(res);
        },
        (error) => {
          return Promise.reject(error);
        }
      );
    },
    updateLoggedInUser: (id, data) => {
      return dispatch(updateLoggedInUserRequest(id, data)).then(
        (res) => {
          return Promise.resolve(res);
        },
        (error) => {
          return Promise.reject(error);
        }
      );
    },
    getSignedUrl: (data) => {
      return dispatch(getSignedUrlRequest(data)).then(
        (res) => {
          return Promise.resolve(res);
        },
        (error) => {
          return Promise.reject(error);
        }
      );
    },
    uploadToS3: (url, file) => {
      return dispatch(uploadToS3Request(url, file)).then(
        (res) => {
          return Promise.resolve(res);
        },
        (error) => {
          return Promise.reject(error);
        }
      );
    },
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(EditProfileFormForDoctors);
